import { axiosInstance } from "@/services/axiosInstance";

export const MerchantNegotiationResource = {
  get: parameters => {
    return axiosInstance.get("v1/merchantnegotiation/:id", {
      urlParams: parameters
    });
  },
  getFees: parameters => {
    return axiosInstance.get("v1/merchantnegotiation/:id/fee", {
      urlParams: parameters
    });
  },
  add: parameters => {
    return axiosInstance.post("v1/merchantnegotiation", parameters);
  },
  update: parameters => {
    return axiosInstance.put("v1/merchantnegotiation", parameters);
  },
  
  simulationTax: parameters => {
    return axiosInstance.post("v1/merchantnegotiation/simulationtax", parameters);
  }
};
